import { CollectindiadataService } from './../services/collectindiadata.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Chart} from 'node_modules/chart.js';

@Component({
  selector: 'app-statewisecomponent',
  templateUrl: './statewisecomponent.component.html',
  styleUrls: ['./statewisecomponent.component.css']
})
export class StatewisecomponentComponent implements OnInit {
  data;
  idData;
  id;
  districtData;
  constructor(public activatedRoute: ActivatedRoute, public collectindiadataService: CollectindiadataService) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.collectindiadataService.getData().subscribe( (data) => {
      this.data = data;
      for(var i = 0; i < data.length; i++){
        for(var key in this.data[i]) {
          if(this. data[i][key] === this.id){
            this.idData = this.data[i];
          }
        }
      }
      this.idData = JSON.parse(JSON.stringify(this.idData));
      this.districtData = this.idData.districtData;
      this.createChart();
      // console.log(this.idData.confirmed);
    });
  }
  createChart(){
    var myDoughnutChart = new Chart('mychart', {
      type: 'pie',
      data: {
        labels: ['Confirmed', 'Active', 'Recovered', 'Deaths'],
        datasets: [{
            data: [this.idData.confirmed, this.idData.active, this.idData.recovered, this.idData.deaths],
            backgroundColor: [
                'rgba(255, 0, 0, 0.8)',
                'rgba(255, 108, 0, 0.8)',
                'rgba(77, 255, 0, 0.8)',
                'rgba(58, 51, 59, 0.8)',
            ],
            // borderColor: [
            //   'rgba(255, 0, 0, 0.9)',
            //   'rgba(255, 108, 0, 0.9)',
            //   'rgba(77, 255, 0, 0.9)',
            //   'rgba(58, 51, 59, 0.9)',
            // ],
            borderWidth: 0.5
        }],
        options: {responsive : true,
          aspectRatio: 1,

        },
      },

      });
    }
  ngOnInit(): void {

  }
}
